import { axiosWithAuth } from "../../helpers";

export const agentPaymentsService = {
	getAgentPaymentMethods,
	getPaymentMethod,
	addPaymentMethod,
	updatePaymentMethod,
	editActivePaymentMethod,
	deletePaymentMethod,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getAgentPaymentMethods({ agentId, page, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.desc,
			agent_id: agentId,
		},
		url: `${API_URL}/api/payment_methods`,
	});
}

function addPaymentMethod({
	data,
	id,
}: {
	data: { [key: string]: any };
	id: string;
}) {
	return axiosWithAuth({
		method: "POST",
		data: data,
		url: `${API_URL}/api/agents/${id}/payment_methods`,
	});
}

function getPaymentMethod({
	id,
	paymentMethodId,
}: {
	id: string;
	paymentMethodId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${id}/payment_methods/${paymentMethodId}`,
	};

	return axiosWithAuth(options);
}

function updatePaymentMethod({
	data,
	id,
	paymentMethodId,
}: {
	data: { [key: string]: any };
	id: string;
	paymentMethodId: string;
}) {
	return axiosWithAuth({
		method: "PUT",
		data: data,
		url: `${API_URL}/api/agents/${id}/payment_methods/${paymentMethodId}`,
	});
}
function editActivePaymentMethod({ userId, paymentMethodId, active }) {
	return axiosWithAuth({
		method: "PUT",
		url: `${API_URL}/api/agents/${userId}/payment_methods/${paymentMethodId}/update_active_status?is_active=${active}`,
	});
}

function deletePaymentMethod({ userId, paymentMethodId }) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${API_URL}/api/agents/${userId}/payment_methods/${paymentMethodId}`,
	});
}
